module.exports = __webpack_public_path__ + "img/qichezhengche.761af298.png";